let apiBaseUrl =  'http://localhost:5000/api';
let serverBaseUrl =  'http://localhost:5000';

if (process.env?.REACT_APP_API_BASE_URL) {
 serverBaseUrl = process.env.REACT_APP_API_BASE_URL;
 apiBaseUrl =`${process.env.REACT_APP_API_BASE_URL}/api`;
}

export const API_BASE_URL = apiBaseUrl;
export const SERVER_BASE_URL = serverBaseUrl;

export const USER_TYPES = {
  PATIENT: 'patient',
  PARTNER: 'partner',
  STAFF: 'staff',
  ROOT: 'root',
  TEMP: 'temp'
}

export const NOTIFICATIONS = {
  TYPE: {
    WARNING_YELLOW: 'warning-yellow',
    WARNING_BLUE: 'warning-blue',
    SUCCESS: 'success'
  }
}

export const COLORS = {
  colorPrimary: '#025FA1',
  colorPrimaryLight: '#0d7bc4',
  colorPrimaryLightplus: '#45a0d8',
  colorSecondary: '#1a3b5c',
  colorShade: '#627185',
  colorLight: '#f2f4f6',
  deleteRed: '#F70100',
  successGreen: '#43AA2A'
}

export const LOGO_SIZES = {
  CAPTION: {
    dynamic: 'w-52 md:w-56',
    medium: 'w-40',
    large: 'w-56',
  },
  NO_CAPTION: {
    small: 'w-14',
    medium: 'w-24',
    large: 'w-32',
  },
}

export const PARTNER_TYPES = [
  'Dentist', 'Implantologist', 'Orthodontist', 'Parodontist', 'Endodontist', 'Laboratory'
]

export const PARTNER_TYPES_LIST = {
  dentist: 'Dentist', 
  implantologist: 'Implantologist', 
  orthodontist: 'Orthodontist',
  parodontist: 'Parodontist',
  endodontist: 'Endodontist', 
  laboratory: 'Laboratory'
}

export const CLINIC_TYPES = {
  CoE: 'Center of Excellence',
  clinic: 'Clinic',
  lab: 'Laboratory'
}

export const TREATMENT_TYPES = [
  'Treatment', 'Scan&Go'
]

export const INVOICE_STATUSES = [
  'Pending', 'Paid', 'Refused'
]

export const SCAN_TYPES = {
  FACE_SCAN: '3D Face Scan (STL)', 
  INTRORAL_SCAN: '3D IntraOral Scan (STL)', 
  CBCT_SCAN: '3D CBCT Scan (DICOM)', 
  IMAGE: 'Image', 
  VIDEO: 'Video'
}
